import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;
    const data = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined
    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    <th><Label data="HeaderIntermediates" /></th>
                    <th><Label data="HeaderRank" /></th>
                    <th><Label data="HeaderTime" /></th>
                    <th><Label data="HeaderTimeBehind" /></th>

                </tr>
            </thead>
            <tbody>
                {config && config.filter(rowConf => rowConf.pos !== 'S' && rowConf.code === 'INTERMEDIATE').map((val, key) => {
                    //let res = findObject(data, 'er_pos', val.ei_pos)
                    let res = findArray(data, { er_pos: [val.pos] })
                    return (
                        <tr key={'expanded_' + row.participant.code + '_' + key}>
                            <td>{val.value}<Label data="LabelKm" /></td>
                            <td>{res.er_rank}</td>
                            <td>{res.er_value}</td>
                            <td>{res.er_diff}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.resultAnalysis, nextProps.row.resultAnalysis)
    )
});